import {
  EventInfoResponse,
  PerformerInfoResponse,
  SearchPaginationResponse,
  SearchResponse,
  VenueInfoResponse,
} from '@grpc-clients/external/mercury/v1/entertainment/entertainment.pb';
import { Action } from '@ngrx/store';
import { EntertainmentForm } from '@pages/entertainment/models/entertainment-tickets-config';
import { FormData } from '@shared/store/models/form-data';

export const UPDATE_TiCKET_FORM = '[Entertainment Ticket Search Form] Update ticket form';
export const RESTORE_TICKET_FORM = '[Entertainment Ticket Search Form] Restore ticket form';

export const GET_TICKETS_SEARCH_RESULTS = '[Entertainment Ticket Search Result] Get tickets search results';
export const GET_TICKETS_SEARCH_RESULTS_SUCCESS =
  '[Entertainment Ticket Search Result] Get tickets search results success';
export const GET_TICKETS_SEARCH_RESULTS_FAILURE =
  '[Entertainment Ticket Search Result] Get tickets search results failure';

export const GET_TICKET_EVENT_RESULT = '[Entertainment Ticket Event Search Result] Get ticket event result';
export const GET_TICKET_EVENT_RESULT_SUCCESS =
  '[Entertainment Ticket Event Search Result] Get ticket event result success';
export const GET_TICKET_EVENT_RESULT_FAILURE =
  '[Entertainment Ticket Event Search Result] Get ticket event result failure';
export const CLEAR_TICKET_EVENT_RESULT = '[Entertainment Ticket Event Search Result] Clear ticket event result';

export const GET_TICKETS_PAGINATION_RESULT =
  '[Entertainment Ticket Event Pagination Result] Get ticket event pagination result';
export const GET_TICKETS_PAGINATION_RESULT_SUCCESS =
  '[Entertainment Ticket Event Pagination Result] Get ticket event pagination result success';
export const GET_TICKETS_PAGINATION_RESULT_FAILURE =
  '[Entertainment Ticket Event Pagination Result] Get ticket event pagination result failure';
export const CLEAR_TICKETS_PAGINATION_RESULT =
  '[Entertainment Ticket Event Pagination Result] Clear ticket event pagination result';

export class UpdateTicketForm implements Action {
  readonly type = UPDATE_TiCKET_FORM;
  constructor(public formData: FormData<EntertainmentForm>) {}
}

export class RestoreTicketForm implements Action {
  readonly type = RESTORE_TICKET_FORM;
}

export class GetTicketsSearchResults implements Action {
  readonly type = GET_TICKETS_SEARCH_RESULTS;
  constructor(
    public form: EntertainmentForm,
    public ignoreSearchFormUpdate?: boolean
  ) {}
}

export class GetTicketsSearchResultsSuccess implements Action {
  readonly type = GET_TICKETS_SEARCH_RESULTS_SUCCESS;
  constructor(public results: SearchResponse) {}
}
export class GetTicketsSearchResultsFailure implements Action {
  readonly type = GET_TICKETS_SEARCH_RESULTS_FAILURE;
}

export class GetTicketEventResult implements Action {
  readonly type = GET_TICKET_EVENT_RESULT;
}
export class GetTicketEventResultSuccess implements Action {
  readonly type = GET_TICKET_EVENT_RESULT_SUCCESS;
  constructor(public result: EventInfoResponse | VenueInfoResponse | PerformerInfoResponse) {}
}
export class GetTicketEventResultFailure implements Action {
  readonly type = GET_TICKET_EVENT_RESULT_FAILURE;
}
export class ClearTicketEventResult implements Action {
  readonly type = CLEAR_TICKET_EVENT_RESULT;
}

export class GetTicketsPaginationResult implements Action {
  readonly type = GET_TICKETS_PAGINATION_RESULT;
  constructor(
    public searchToken: string,
    public pageIndex: number
  ) {}
}

export class GetTicketsPaginationResultSuccess implements Action {
  readonly type = GET_TICKETS_PAGINATION_RESULT_SUCCESS;
  constructor(public results: SearchPaginationResponse) {}
}
export class GetTicketsPaginationResultFailure implements Action {
  readonly type = GET_TICKETS_PAGINATION_RESULT_FAILURE;
}
export class ClearTicketsPaginationResult implements Action {
  readonly type = CLEAR_TICKETS_PAGINATION_RESULT;
}

export type EntertainmentTicketSearchActions =
  | UpdateTicketForm
  | RestoreTicketForm
  | GetTicketsSearchResults
  | GetTicketsSearchResultsSuccess
  | GetTicketsSearchResultsFailure
  | GetTicketEventResult
  | GetTicketEventResultSuccess
  | GetTicketEventResultFailure
  | ClearTicketEventResult
  | GetTicketsPaginationResult
  | GetTicketsPaginationResultSuccess
  | GetTicketsPaginationResultFailure
  | ClearTicketsPaginationResult;
